import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  TextField,
  Button,
  IconButton
} from "@mui/material";
import { MdClose, MdBlock } from "react-icons/md";
import VoiceMicButton from "../../components/VoiceMicButton";

export default function BlockReasonModal({ open, onClose, onSubmit, task }) {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError("Please enter a reason for blocking this task.");
      return;
    }
    setError("");
    onSubmit(reason.trim());
    setReason("");
  };

  const handleCancel = () => {
    setReason("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} fullWidth maxWidth="xs" PaperProps={{ sx: { borderRadius: "12px" } }}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <MdBlock size={20} style={{ color: "#ef4444" }} />
          <Typography variant="h6" fontSize={16} fontWeight={700} color="#1e293b">
            Block Task
          </Typography>
        </Box>
        <IconButton onClick={handleCancel} size="small" sx={{ color: "#64748b" }}>
          <MdClose size={20} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <Typography variant="body2" color="#64748b" sx={{ mb: 1.5 }}>
          You are marking <strong>{task?.task_name || "this task"}</strong> as <strong>Blocked</strong>. Please provide a clear reason so the assigned Manager and Reviewer can assist.
        </Typography>

        <TextField
          fullWidth
          multiline
          rows={3}
          placeholder="e.g. Waiting for client GST credentials, or missing bank statements..."
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (e.target.value.trim()) setError("");
          }}
          error={Boolean(error)}
          helperText={error}
          inputProps={{
            style: {
              color: "#0f172a",
              fontSize: "13px",
              lineHeight: "1.5"
            }
          }}
          InputProps={{
            endAdornment: (
              <VoiceMicButton
                initialText={reason}
                onTranscript={(text) => {
                  setReason(text);
                  if (text.trim()) setError("");
                }}
              />
            )
          }}
          sx={{
            backgroundColor: "#ffffff",
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              backgroundColor: "#ffffff",
              color: "#0f172a",
              "& fieldset": {
                borderColor: "#cbd5e1"
              },
              "&:hover fieldset": {
                borderColor: "#94a3b8"
              },
              "&.Mui-focused fieldset": {
                borderColor: "#2563eb"
              }
            },
            "& .MuiInputBase-input": {
              color: "#0f172a !important",
              WebkitTextFillColor: "#0f172a !important"
            },
            "& .MuiInputBase-input::placeholder": {
              color: "#94a3b8 !important",
              opacity: 1
            }
          }}
        />
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 1, borderTop: "1px solid #f1f5f9" }}>
        <Button onClick={handleCancel} color="inherit" sx={{ textTransform: "none", fontWeight: 600, color: "#64748b" }}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            textTransform: "none",
            fontWeight: 600,
            backgroundColor: "#ef4444",
            "&:hover": { backgroundColor: "#dc2626" },
            borderRadius: "8px"
          }}
        >
          Submit & Notify Manager
        </Button>
      </DialogActions>
    </Dialog>
  );
}
